"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/** Parses the laquesisff cookie content.
 *
 * @param {String} cookie - laquesisff cookie (it can be obtained from `getFeatureFlagCookie(document.cookie)`
 * @return {Object} Experiments with active variant.
 */
function parse(cookie) {
  if (!cookie) return {};
  const regex = /^(.+)$/;
  return cookie.split('#').reduce((flags, experiment) => {
    const match = experiment.match(regex);
    if (match) flags[match[1].trim().toUpperCase()] = true;
    return flags;
  }, {});
}
var _default = parse;
exports.default = _default;